/**
 * Class Name Merger Utility
 * Combines clsx() for conditional classes with tailwind-merge to resolve conflicts.
 * Usage: cn("px-4 py-2", condition && "bg-primary", "px-6") => "py-2 bg-primary px-6"
 */
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
